import { useRef } from 'react';
import { TextField } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';

type MKDateProps = {
  label: string;
  value: string;        // YYYY-MM-DD or ''
  onChange: (value: string) => void;
  required?: boolean;
  fullWidth?: boolean;
  error?: boolean;
  helperText?: string;
  futureOnly?: boolean; // sets the calendar's min date to today
  sx?: SxProps<Theme>;
};

export function MKDate({
  label,
  value,
  onChange,
  required,
  fullWidth,
  error,
  helperText,
  futureOnly,
  sx,
}: MKDateProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  const openPicker = () => inputRef.current?.showPicker?.();

  // Values only ever come from the native calendar widget, never the keyboard.
  const blockTyping = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Tab') return;
    e.preventDefault();
  };

  return (
    <TextField
      label={label}
      type="date"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onClick={openPicker}
      onFocus={openPicker}
      onKeyDown={blockTyping}
      required={required}
      fullWidth={fullWidth}
      error={error}
      helperText={helperText}
      InputLabelProps={{ shrink: true }}
      inputRef={inputRef}
      inputProps={{
        min: futureOnly ? new Date().toISOString().slice(0, 10) : undefined,
        style: { cursor: 'pointer' },
      }}
      sx={sx}
    />
  );
}
